module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instagram-post-embed"
  }, [(_vm.permalink) ? _c('blockquote', {
    key: _vm.permalink,
    staticClass: "instagram-media",
    attrs: {
      "data-instgrm-permalink": _vm.permalink,
      "data-instgrm-version": "14"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.permalink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("View on Instagram")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753511ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/InstagramPostEmbed.vue
// module id = 2202
// module chunks = 0